import { z } from "zod";

import { entityLevelSchema, entityTypeSchema } from "../../Entity/schemas/entity";

export const entityProfileEditSchema = z.object({
  mediaUrl: z.string().optional(),
  mediaFile: z.instanceof(File).optional(),
  // entityName: z.string({ required_error: "NAME_REQUIRED" }).min(1, "NAME_REQUIRED"),
  name_ar: z.string({ required_error: "ARABIC_NAME_REQUIRED" }).min(1, "ARABIC_NAME_REQUIRED"),
  name_en: z.string({ required_error: "ENGLISH_NAME_REQUIRED" }).min(1, "ENGLISH_NAME_REQUIRED"),
  level: entityLevelSchema,
  type: entityTypeSchema,
  countryId: z.number({ required_error: "COUNTRY_REQUIRED" }).min(1, "COUNTRY_REQUIRED"),
  foundedYear: z.number({ required_error: "ESTABLISHED_YEAR_REQUIRED" }).min(1, "ESTABLISHED_YEAR_REQUIRED"),
  about: z.string().optional(),
  listEntry: z.array(z.number({ required_error: "PLAYING_LEVEL_REQUIRED" })).min(1, "PLAYING_LEVEL_REQUIRED"),
});

export const entityAchievementsEditSchema = z.object({
  nationalLeague: z.coerce.number({ invalid_type_error: "NUMBER_REQUIRED" }),
  nationalCup: z.coerce.number({ invalid_type_error: "NUMBER_REQUIRED" }),
  nationalTournament: z.coerce.number({ invalid_type_error: "NUMBER_REQUIRED" }),
  internationalTournament: z.coerce.number({ invalid_type_error: "NUMBER_REQUIRED" }),
});

export const branchBasicInfoSchema = z.object({
  branchName: z.string({ required_error: "NAME_REQUIRED" }).min(1, "NAME_REQUIRED"),
  branchAddress: z.string({ required_error: "ADDRESS_REQUIRED" }).min(1, "ADDRESS_REQUIRED"),
  branchGoogleMapsAddress: z
    .string({ required_error: "GOOGLE_MAP_LINK_REQUIRED" })
    .url({ message: "GOOGLE_MAP_LINK_REQUIRED" }),
  isHeadquarters: z.boolean().optional().default(false),
});

export const dayWorkingHoursSchema = z
  .object({
    openingTime: z.string().regex(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, "INVALID_TIME_FORMAT"),
    closingTime: z.string().regex(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, "INVALID_TIME_FORMAT"),
  })
  .optional();

export const branchWorkingHoursSchema = z.object({
  workingHours: z.object({
    saturday: dayWorkingHoursSchema,
    sunday: dayWorkingHoursSchema,
    monday: dayWorkingHoursSchema,
    tuesday: dayWorkingHoursSchema,
    wednesday: dayWorkingHoursSchema,
    thursday: dayWorkingHoursSchema,
    friday: dayWorkingHoursSchema,
  }),
});

export const branchSportsSchema = z.object({
  sports: z.array(z.number()).min(1, "SPORTS_REQUIRED"),
});

export const branchFacilitiesSchema = z.object({
  facilities: z.array(
    z.object({
      facilityId: z.number(),
      count: z.number().default(0),
    })
  ),
});

export const entityBranchSchema = branchBasicInfoSchema
  .merge(branchWorkingHoursSchema)
  .merge(branchSportsSchema)
  .merge(branchFacilitiesSchema);

export const EntityLocationSchema = z.object({
  country: z.coerce.number({ required_error: "COUNTRY_REQUIRED" }).min(1, "COUNTRY_REQUIRED"),
  branches: z.array(entityBranchSchema),
});

export const addEntityLocationsSchema = z.object({
  locations: z.array(EntityLocationSchema),
});
